// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__24Eje","title":"FrontImage_title__2SRE5"};